import { render, staticRenderFns } from "./importRecords.vue?vue&type=template&id=7e815d70&scoped=true&"
import script from "./importRecords.vue?vue&type=script&lang=js&"
export * from "./importRecords.vue?vue&type=script&lang=js&"
import style0 from "./importRecords.vue?vue&type=style&index=0&id=7e815d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e815d70",
  null
  
)

export default component.exports